import { maybe } from "shared/maybe"
import { Nil } from "shared/misc"
import { uploadUrl } from "shared/upload"
import { ERROR_ICON } from "ui/icons"
import { ThumbnailOptions } from "ui/thumbnail"
import Thumbnail from "ui/thumbnail/Thumbnail"
import ThumbnailIconBox from "ui/thumbnail/box/ThumbnailIconBox"
import { UPLOADS_URL } from "../config.js"

//TODO is this the only place we need this class? seems like itd be elsewhere too
export interface UploadMeta {

    readonly name: string
    readonly type: string
    readonly width?: number | Nil
    readonly height?: number | Nil
    readonly present: 0 | 1 | boolean

}

export interface PublicThumbnailProps extends ThumbnailOptions {

    readonly id: string
    readonly companyId: number
    readonly upload: UploadMeta

}

export default function PublicThumbnail(props: PublicThumbnailProps) {
    if (!props.upload.present) {
        return <ThumbnailIconBox {...props} iconText="Not Available" icon={ERROR_ICON} />
    }
    const urls = uploadUrl(UPLOADS_URL, props.companyId, props.id)
    const file = {
        name: props.upload.name,
        type: props.upload.type,
        url: urls.url,
        thumbnail: maybe(urls.transform, transform => {
            return (width?: number | undefined, height?: number | undefined) => {
                return transform({
                    width,
                    height,
                    quality: 50,
                    format: "avif",
                })
            }
        }),
    }
    return <Thumbnail {...props} file={file} />
}
